import { BaseModel } from 'paliari-js-utils'
import { required, minLength } from 'vuelidate/lib/validators'

export const attributes = () => ({
  id: null,
  nome: '',
})

export default class UsuarioGrupo extends BaseModel {
  constructor(obj) {
    super(attributes(), obj)
  }

  static get validations() {
    return {
      nome: { required, minLength: minLength(5) },
    }
  }
}
